import { WINDOW_PLANE_ID } from './readWindowPlaneSize';

/**
 * 창을 키보드로 닫거나 최소화하면 닫기/최소화 버튼이 unmount/display:none 되어
 * document.activeElement 가 body 로 추락한다 — 다음 Tab 이 문서 최상단부터 재시작.
 * 사라지기 직전 frame 내부에 포커스가 있을 때만 윈도우 평면으로 포커스를 이양한다.
 *
 * 타깃 우선순위: #window-plane → #main-content → document.body.
 * 타깃이 포커스 불가면 tabIndex=-1 을 세팅해 프로그래매틱 포커스만 허용(탭 순서 비참여).
 * 포커스가 frame 밖이면 no-op — 다른 창/표면의 포커스를 가로채지 않는다.
 */
export function releaseFocusToMain(frame: HTMLElement | null): void {
  if (typeof document === 'undefined') return;
  if (!frame) return;
  const active = document.activeElement;
  // 사라지는 frame 내부에 포커스가 있을 때만 이양 — 밖이면 가로채지 않는다.
  if (!(active instanceof HTMLElement) || !frame.contains(active)) return;

  const target =
    document.getElementById(WINDOW_PLANE_ID) ??
    document.getElementById('main-content') ??
    document.body;
  if (!target) return;

  // tabindex 없는 컨테이너(div)는 포커스 불가 — -1 로 프로그래매틱 포커스만 허용.
  if (!target.hasAttribute('tabindex')) {
    target.setAttribute('tabindex', '-1');
  }
  target.focus({ preventScroll: true });
}
